module.exports = __webpack_public_path__ + "img/hxw.d8daf006.jpg";